
if (!String.prototype.isEmpty) {
	String.prototype.isEmpty = function () {
		return (this == null || this === '');
	};
}



if (!String.prototype.toTitleCase) {
	String.prototype.toTitleCase = function () {
		var output = [];
		var strings = this.split(" ");
		for (var i=0; i < strings.length; i++) {
			var txt = strings[i].charAt(0).toUpperCase() + strings[i].substr(1).toLowerCase();
			output.push(txt);
		}
		return output.join(" ");
		//return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
	};
}



/** WEBPACK FOOTER **
 ** ./src/js/string.js
 **/